// src/services/simuladoService.ts

import { Simulado, CreateSimuladoData, SimuladoAnswer } from '../types/simulado.types';

const API_BASE_URL = '/api';

class SimuladoService {
    private getHeaders(): HeadersInit {
        const token = localStorage.getItem('accessToken');
        return {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        };
    }

    /**
     * Listar simulados do usuário
     */
    async getSimulados(status?: string): Promise<Simulado[]> {
        const params = new URLSearchParams();
        if (status) params.append('status', status);

        const response = await fetch(
            `${API_BASE_URL}/simulados?${params.toString()}`,
            { headers: this.getHeaders() }
        );

        if (!response.ok) {
            throw new Error('Erro ao buscar simulados');
        }

        const data = await response.json();
        return data.simulados;
    }

    /**
     * Criar simulado
     */
    async createSimulado(data: CreateSimuladoData): Promise<Simulado> {
        const response = await fetch(
            `${API_BASE_URL}/simulados/create`,
            {
                method: 'POST',
                headers: this.getHeaders(),
                body: JSON.stringify(data)
            }
        );

        if (!response.ok) {
            const error = await response.json();
            throw new Error(error.message || 'Erro ao criar simulado');
        }

        const result = await response.json();
        return result.simulado;
    }

    /**
     * Obter simulado específico
     */
    async getSimulado(simuladoId: string): Promise<Simulado> {
        const response = await fetch(
            `${API_BASE_URL}/simulados/${simuladoId}`,
            { headers: this.getHeaders() }
        );

        if (!response.ok) {
            throw new Error('Erro ao buscar simulado');
        }

        const data = await response.json();
        return data.simulado;
    }

    /**
     * Iniciar simulado
     */
    async startSimulado(simuladoId: string): Promise<Simulado> {
        const response = await fetch(
            `${API_BASE_URL}/simulados/${simuladoId}/start`,
            {
                method: 'POST',
                headers: this.getHeaders()
            }
        );

        if (!response.ok) {
            throw new Error('Erro ao iniciar simulado');
        }

        const data = await response.json();
        return data.simulado;
    }

    /**
     * Finalizar simulado
     */
    async finishSimulado(simuladoId: string, answers: SimuladoAnswer[]): Promise<Simulado> {
        const response = await fetch(
            `${API_BASE_URL}/simulados/${simuladoId}/finish`,
            {
                method: 'POST',
                headers: this.getHeaders(),
                body: JSON.stringify({ answers })
            }
        );

        if (!response.ok) {
            throw new Error('Erro ao finalizar simulado');
        }

        const data = await response.json();
        return data.simulado;
    }

    /**
     * Deletar simulado
     */
    async deleteSimulado(simuladoId: string): Promise<void> {
        const response = await fetch(
            `${API_BASE_URL}/simulados/${simuladoId}`,
            {
                method: 'DELETE',
                headers: this.getHeaders()
            }
        );

        if (!response.ok) {
            throw new Error('Erro ao deletar simulado');
        }
    }
}

export const simuladoService = new SimuladoService();